import {
  Component, Input, HostBinding
} from '@angular/core';

@Component({
  selector: 'sondermind-side-nav',
  templateUrl: './side-nav.component.html',
  standalone: false
})
export class SideNavComponent {
  @HostBinding('class.sondermind-side-nav')
    bindClass = true;

  @Input() @HostBinding('attr.alert')
    alert = false;
}
